import NukaCarousel from "nuka-carousel";
import { node, string, bool, func, number } from "prop-types";
import React, { useEffect, useRef } from "react";
import { twMerge } from "tailwind-merge";

import { useIsInitialRender } from "@hooks/useIsInitialRender";

const Carousel = ({
  children,
  className,
  afterSlide,
  currentIndex,
  isHidden = false,
}) => {
  const isInitialRender = useIsInitialRender();

  const ref = useRef();

  useEffect(() => {
    ref.current = currentIndex;
  }, [currentIndex]);

  return (
    <div
      className={twMerge(
        "block h-full pl-[6vw] relative [&_.slider-slide]:!outline-none",
        "lg:size-full lg:p-0 lg:overflow-hidden",
        isHidden && "invisible",
        isInitialRender && "[&_.slider-frame]:bg-white",
        className
      )}
    >
      {isInitialRender ? (
        <div className="size-full">{children[currentIndex]}</div>
      ) : (
        <NukaCarousel
          heightMode="current"
          slideIndex={currentIndex}
          afterSlide={afterSlide}
          cellSpacing={5}
          frameOverflow="visible"
          withoutControls
          swiping
        >
          {children}
        </NukaCarousel>
      )}
    </div>
  );
};

Carousel.propTypes = {
  children: node.isRequired,
  afterSlide: func.isRequired,
  shouldWrapAround: bool,
  className: string,
  currentIndex: number,
  isHidden: bool,
};

export default Carousel;
